import { ColDef, ColType } from '../../interfaces/colDef';

// Column definitions for bst-cv-list when it runs as a DualAxisDelegate.
// The shape mirrors coldefs-{user,project,client}.ts: ColDef[] with name,
// title (translation key or literal), type, and sort/filter flags. The
// cv-list component provides a cellTemplateOutlet that renders each row
// for the specific column types listed here (date, string, int via the
// existing template-object switch family is more than this surface
// needs; cv-list renders directly in its own template).
//
// Filter funnels and sort arrows appear in the dual-axis header for any
// column that has `filter: true` and/or `sort: true`. They route back
// into the delegate via the events subject; the GeneratedCvQueryBuilder
// then translates those into Elasticsearch / SQL clauses.

export const stickyColumns: ColDef[] = [];

export const columns: ColDef[] = [
  {
    name: 'created_at',
    title: 'cv.list.columns.date',
    type: ColType.DATE,
    required: false,
    sort: true,
    filter: true,
  },
  {
    name: 'template_id',
    title: 'cv.list.columns.template',
    type: ColType.STRING,
    required: false,
    sort: true,
    filter: true,
  },
  {
    name: 'subject_user_name',
    title: 'cv.list.columns.subjectUser',
    type: ColType.STRING,
    required: false,
    sort: true,
    filter: true,
  },
  {
    name: 'client_name',
    title: 'cv.list.columns.client',
    type: ColType.STRING,
    required: false,
    sort: true,
    filter: true,
  },
  {
    name: 'locale',
    title: 'cv.list.columns.locale',
    type: ColType.STRING,
    required: false,
    sort: true,
    filter: true,
  },
  {
    name: 'pdf_size_bytes',
    title: 'cv.list.columns.size',
    type: ColType.INT,
    required: false,
    sort: true,
    filter: false,
  },
  {
    name: 'expires_at',
    title: 'cv.list.columns.expires',
    type: ColType.DATE,
    required: false,
    sort: true,
    filter: true,
  },
];

// Custom column: the cellTemplate renders the per-row action buttons
// (preview / download / delete). filter+sort off; pinned to the right
// edge as a sticky column so the icons stay visible even when the data
// columns overflow into a horizontal scroll.
export const stickyColumnsRight: ColDef[] = [
  {
    name: 'actions',
    title: 'cv.list.columns.actions',
    type: ColType.CUSTOM,
    required: false,
    filter: false,
    sort: false,
  },
];
